import { MANIFESTO as MANIFESTO_FALLBACK } from "@/data";
import { Reveal, Overline } from "@/components/Reveal";
import { useCollection } from "@/hooks/useCollection";

export const Manifesto = () => {
  const { data: MANIFESTO } = useCollection("manifesto", "/manifesto", MANIFESTO_FALLBACK);

  return (
    <section id="prinsip" className="bg-cream py-24 md:py-36 px-6 md:px-10 border-t border-border/60">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Overline>Prinsip Kami</Overline>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-ink mb-14 max-w-2xl">
            Cara kami menjaga setiap tetes tetap murni.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.no} delay={i * 0.1}>
              <div className="border-t border-border/60 pt-8">
                <span className="block font-display text-5xl md:text-6xl text-honey/90 leading-none mb-4">
                  {m.no}
                </span>
                <h3 className="font-display text-2xl md:text-3xl tracking-tight text-ink mb-2">
                  {m.title}
                </h3>
                <p className="text-stone2 leading-relaxed">{m.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
